"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
exports.Fieldset = styled_components_1.default.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  row-gap: ", "px;\n"], ["\n  border: 0;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  row-gap: ", "px;\n"])), accessors_1.space('xl'));
var templateObject_1;
